<template>
	<div>
		<div class="w-full d-flex">
			<div class="w-full d-flex flex-column align-items-center">
				<div
					class="w-full d-flex flex-column align-items-center"
					:class="
						type !== 'fit'
							? 'md:w-8/12 xl:w-6/12 xxl:w-8/12'
							: 'w-full'
					"
				>
					<!-- <div class="w-full d-flex items-center justify-center">
						<div class="d-block mb-5 text-md-center max-500">
							<span>{{ label }}</span>
							<template v-if="type == 'scheduling'">
								<h4 class="font-24 font-md-32 m-0">Escolha o horário do agendamento</h4>
							</template>
							<template v-else-if="type == 'fit'">
								<h4 class="font-24 font-md-32 m-0">Escolha a agenda de encaixe</h4>
							</template>
						</div>
					</div> -->
					<div
						class="w-full"
						style="max-width: 550px"
					>
						<div
							class="row justify-content-between align-items-center mb-4 mb-md-3"
						>
							<div class="col-auto pr-0">
								<div class="d-flex align-items-end">
									<template v-if="type == 'scheduling'">
										<button
											v-if="today_is_first_day"
											class="btn btn-light btn-sm disabled"
											v-tippy="{
												arrow: 'top',
												content:
													'O dia selecionado é o primeiro dia desta agenda.',
											}"
										>
											<i class="far fa-chevron-left"></i>
										</button>
										<button
											v-else
											@click="PreviousDay"
											class="btn btn-light btn-sm"
										>
											<i class="far fa-chevron-left"></i>
										</button>
										<div class="text-center mx-3 mx-md-4">
											<small>dia</small>
											<h6 class="d-block">
												{{
													GetFormattedDayOfWeek(
														days[position]
													)
												}}
											</h6>
											<h4 class="font-18 font-md-20">
												{{ FormatDate(days[position]) }}
											</h4>
										</div>
										<button
											v-if="today_is_last_day"
											class="btn btn-light btn-sm disabled"
											v-tippy="GetDayTooltipText()"
										>
											<i class="far fa-chevron-right"></i>
										</button>
										<button
											v-else
											class="btn btn-light btn-sm"
											@click="NextDay"
										>
											<i class="far fa-chevron-right"></i>
										</button>
									</template>
								</div>
							</div>
						</div>

						<div class="card bg-light border-no overflow-hidden">
							<div class="card-body p-3 p-md-5 scroll-this">
								<template v-if="type == 'scheduling'">
									<template
										v-if="
											days[position] &&
											times[days[position]].length > 0
										"
									>
										<div
											v-for="time in customSort(
												times[days[position]]
											)"
											:key="time.id"
											@click="Continue(time)"
										>
											<div
												v-if="time.tipo === 1"
												class="select-card with-border mt-3"
											>
												<label>
													{{ time.hora.slice(0, 5) }}
													{{ time.schedule.nome }}
													<i
														class="far fa-chevron-right"
													></i>
												</label>
											</div>
											<div
												v-else-if="time.tipo == 3"
												class="select-card select-blue with-border mt-3"
											>
												<label>
													ESPERA -
													{{ time.schedule.nome }}
													<i
														class="far fa-chevron-right"
													></i>
												</label>
											</div>
										</div>
									</template>
									<template v-else>
										<div
											class="d-flex justify-content-center"
										>
											<span
												>Não há horários
												disponíveis.</span
											>
										</div>
									</template>
								</template>
								<template v-else-if="type == 'fit'">
									<div
										v-for="fit in fits"
										:key="fit.id"
										@click="Continue(fit)"
									>
										<div
											class="select-card select-orange with-border mt-3"
										>
											<label>
												ENCAIXE - {{ fit.nome }}
												<i
													class="far fa-chevron-right"
												></i>
											</label>
										</div>
									</div>
								</template>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	const moment = require('moment')
	moment.locale('pt')

	const _ = require('lodash')

	import Swal from 'sweetalert2'
	import { mapActions, mapGetters } from 'vuex'
	export default {
		name: 'Schedules',
		components: {},
		props: {
			label: {
				type: String,
				default: '',
			},
			modality_id: {
				type: [String, Number],
				default: null,
			},
			proceedings: {
				type: Array,
				default: () => [],
			},
			schedules: {
				type: Array,
				default: () => [],
			},
			type: {
				type: String,
				default: 'scheduling',
			},
		},
		data() {
			return {
				interval: 60,
				filters: {
					weekdays: [],
					period: [1, 2, 3],
					date_init: '',
					date_end: '',
					schedules: [],
				},
				days: [],
				times: [],
				fits: [],
				position: 0,
			}
		},
		watch: {
			proceedings: {
				handler(val) {
					this.GetVacancySchedules()
				},
				deep: true,
			},
			schedules(val) {
				this.GetVacancySchedules()
			},
		},
		computed: {
			...mapGetters('auth', ['requester_selected_id']),
			today_is_first_day() {
				return this.position === 0
			},
			today_is_last_day() {
				return (
					!this.days.length || this.position == this.days.length - 1
				)
			},
		},
		methods: {
			...mapActions('system', ['StartLoading', 'FinishLoading']),
			GetVacancySchedules() {
				if (this.type == 'fit') {
					this.fits = [...this.schedules]
				} else if (this.type == 'scheduling') {
					this.StartLoading()

					// Datas internas para uso na requisição
					const effective_date_init =
						this.filters.date_init || moment().format('YYYY-MM-DD')
					const effective_date_end =
						this.filters.date_end ||
						moment().add(this.interval, 'days').format('YYYY-MM-DD')

					let obj = {
						account_id: this.requester_selected_id,
						modality_id: this.modality_id,
						proceedings: this.proceedings,
						schedules:
							this.filters.schedules.length > 0
								? this.filters.schedules
								: this.schedules,
						filters: {
							...this.filters,
							date_init: effective_date_init,
							date_end: effective_date_end,
						},
					}

					window.api
						.call('post', '/get-vacancy-schedules', obj)
						.then(({ data }) => {
							if (data.response) {
								let days = Object.keys(data.days)

								this.days = _.sortBy(days, o => new Date(o))

								this.times = data.days

								this.position = 0
							} else {
								Swal.fire({
									title: 'Eita !',
									text: 'Houve um erro ao obter, contate o suporte',
									icon: 'error',
								})
							}
						})
						.finally(() => {
							this.FinishLoading()
						})
				}
			},
			ResetFilters() {
				this.filters.weekdays = [0, 1, 2, 3, 4, 5, 6]
				this.filters.period = [1, 2, 3]
				this.filters.date_init = moment().format('YYYY-MM-DD')
				this.filters.date_end = moment()
					.add(this.interval, 'day')
					.format('YYYY-MM-DD')
			},
			PreviousDay() {
				this.position = this.days[this.position - 1]
					? this.position - 1
					: 0
			},
			async NextDay() {
				if (this.today_is_last_day) return

				if (this.position + 1 === this.days.length) {
					this.filters.date_end = moment(this.filters.date_end)
						.add(this.interval, 'day')
						.format('YYYY-MM-DD')

					await this.GetVacancySchedules()

					this.position = this.days[this.position + 1]
						? this.position + 1
						: this.position
				} else {
					this.position = this.days[this.position + 1]
						? this.position + 1
						: this.position
				}
			},
			FormatDate(date) {
				return window.helpers.FormatDate(date)
			},
			Previous() {
				this.$emit('previous')
			},
			Continue(time) {
				this.$emit('next', time)
			},
			customSort(times) {
				return _.sortBy(times, ['dia', 'hora'])
			},
			CloseModal(modal_id) {
				window.jQuery(modal_id).modal('hide')
			},
			GetDayTooltipText() {
				let content = ''

				if (!this.days.length) {
					content = 'Não há dias configurados na agenda.'
				}

				if (this.position == this.days.length - 1) {
					content = 'O dia selecionado é o último dia desta agenda.'
				}

				return {
					arrow: true,
					hideOnClick: false,
					content,
				}
			},
			ApplyFilters(newFilters) {
				this.filters = newFilters
				this.GetVacancySchedules()
			},
			GetFormattedDayOfWeek(date) {
				return moment(date).format('dddd')
			},
		},
		mounted() {
			this.GetVacancySchedules()

			document.addEventListener('keyup', e => {
				if (e.keyCode === 27) {
					this.CloseModal('#modal-filter')
				}
			})
		},
	}
</script>

<style lang="css" scoped>
	.w-100 {
		max-width: calc(100% - 800px);
	}

	@media screen and (max-width: 1899px) {
		.w-100 {
			max-width: calc(100% - 660px);
		}
	}

	@media screen and (max-width: 1599px) {
		.w-100 {
			max-width: calc(100% - 500px);
		}
	}

	@media screen and (max-width: 1279px) {
		.w-100 {
			max-width: calc(100% - 400px);
		}
	}

	.disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}

	.disabled:hover,
	.disabled:active,
	.disabled:focus {
		color: var(--gray-light) !important;
	}

	.filters-sidebar-placeholder {
		width: 400px;
		height: 100%;
	}

	.filters-sidebar-hidden {
		width: 0 !important;
	}

	.has-filters-dot::after {
		content: '';
		background-color: #e0dd2e;
		width: 12px;
		height: 12px;
		border: solid 1px #e0dd2e;
		border-radius: 50%;
		z-index: 9;
		right: -5px;
		top: -5px;
		position: absolute;
	}

	.has-filters-button {
		background-color: #a3a121 !important;
		color: #fff !important;
		text-shadow: 0px 0px 7px #fff !important;
	}
</style>
